// Task list — keyed by list key ("tasks" for the standalone Task agenda page).
export const TASK_ACTION_GET_TASK_LIST = 'CAL_TASK_ACTION_GET_TASK_LIST'
export const TASK_SET_FETCHING_TASK_LIST = 'CAL_TASK_SET_FETCHING_TASK_LIST'
export const TASK_SET_TASK_LIST = 'CAL_TASK_SET_TASK_LIST'
// Replays every task list slice with its last request args — dispatched after a status
// toggle so the agenda stays fresh (the Calendar Task PATCH carries no list context).
export const TASK_ACTION_REFRESH_LISTS = 'CAL_TASK_ACTION_REFRESH_LISTS'

export const TASK_ACTION_CREATE_TASK = 'CAL_TASK_ACTION_CREATE_TASK'
export const TASK_ACTION_UPDATE_TASK = 'CAL_TASK_ACTION_UPDATE_TASK'
export const TASK_ACTION_DELETE_TASK = 'CAL_TASK_ACTION_DELETE_TASK'

// Single task record — keyed by taskKey (uid) for the detail sidebar.
export const TASK_ACTION_GET_TASK = 'CAL_TASK_ACTION_GET_TASK'
export const TASK_SET_FETCHING_TASK = 'CAL_TASK_SET_FETCHING_TASK'
export const TASK_SET_TASK = 'CAL_TASK_SET_TASK'
